import { ChipProps, Chip, makeStyles } from "@material-ui/core";
import CheckIcon from "@material-ui/icons/Check";
import clsx from "clsx";
import * as React from "react";

import { semanticColors as colors } from "@/designTokens";

interface CustomChipProps extends ChipProps {
  label: string;
  outlined?: boolean;
  selected?: boolean;
}
const useStyles = makeStyles({
  root: { position: "relative" },
  interactive: { "&::before": { content: "\"\"", position: "absolute", inset: "-6px 0", borderRadius: "inherit" } },
  selected: {
    "&&": {
      backgroundColor: colors["state/selected-bg"],
      color: colors["action/primary"],
      borderColor: colors["action/primary"],
    },
    "& .MuiChip-label": { paddingLeft: 4 },
  },
  check: { "&&": { fontSize: 16, marginLeft: 12, marginRight: 0, color: "inherit" } },
  disabled: {
    "&&": {
      backgroundColor: colors["surface/subtle"],
      borderColor: colors["border/default"],
      color: colors["text/disabled"],
      opacity: 1,
    },
  },
});

export const CustomChip: React.FC<CustomChipProps> = ({
  label,
  outlined = false,
  selected = false,
  className,
  disabled,
  onClick,
  icon,
  ...props
}) => {
  const classes = useStyles();
  return (
    <Chip
      {...props}
      label={label}
      size="medium"
      variant={outlined ? "outlined" : "default"}
      color="default"
      disabled={disabled}
      onClick={disabled ? undefined : onClick}
      aria-pressed={onClick ? selected : undefined}
      icon={selected ? <CheckIcon className={classes.check} aria-hidden="true" /> : icon}
      className={clsx(
        classes.root,
        onClick && classes.interactive,
        selected && classes.selected,
        disabled && classes.disabled,
        className
      )}
    />
  );
};
